import { render, staticRenderFns } from "./Libro_mayor.vue?vue&type=template&id=f4b96150&lang=pug&"
import script from "./Libro_mayor.vue?vue&type=script&lang=js&"
export * from "./Libro_mayor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports